import React, { Component } from 'react';
import { Col } from 'reactstrap';
import styles from './Header4.module.css';

export default class Header4 extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <Col xs="12">
                <h4 className={styles.header4}>{this.props.children}</h4>
            </Col>
        );
    }
}
